import React, { useEffect, useState } from 'react';
import T from 'utils/useLocalizer';

import InfiniteScroll from 'react-infinite-scroller';

import { IPaginatedList, ListHeaderItem } from 'models/commonModel';
import { IOrder, ORDER_SORT } from 'models/ordersModel';
import { TableSkeleton } from 'components/ui/skeleton/skeleton';
import EmptyState from 'components/ui/emptyState/EmptyState';
import Error from 'components/ui/error/Error';
import SortableListHeader from 'components/ui/sortableList/SortableListHeader';
import OrdersListItem from './OrdersListItem';
import { common } from 'utils/resources';

interface Props {
  pages: IPaginatedList<IOrder>[];
  fetchMoreHandler: (options?: any) => any;
  hasMore?: boolean;
  isLoading?: boolean;
  isError?: boolean;
}

const OrdersList = ({
  pages,
  isLoading,
  isError,
  fetchMoreHandler,
  hasMore,
}: Props) => {

  const [items, setItems] = useState<IOrder[]>([]);

  const [order] = useState<'asc' | 'desc'>('desc');
  const [orderBy] = useState<ORDER_SORT>();

  const resources = {
    orderNoLabel: T('orders.order.no.label'),
    customerNameLabel: T('orders.customer.name.label'),
    amountLabel: T('orders.amount.label'),
    statusLabel: T('orders.status.label'),
    noteLabel: T('orders.note.label'),
    createdOnLabel: T('orders.created.on.label'),
    invoiceLabel: T('orders.invoice.label'),
    noDataTitle: T(common.noData),
  };

  const headerItems: ListHeaderItem<ORDER_SORT>[] = [
    {
      id: ORDER_SORT.ORDER_NO,
      label: resources.orderNoLabel,
      sortable: false,
    },
    {
      id: ORDER_SORT.CUSTOMER_NAME,
      label: resources.customerNameLabel,
      sortable: false,
    },
    {
      id: ORDER_SORT.TOTAL,
      label: resources.amountLabel,
      sortable: false,
    },
    {
      id: ORDER_SORT.STATUS,
      label: resources.statusLabel,
      sortable: false,
    },
    {
      id: ORDER_SORT.NOTE,
      label: resources.noteLabel,
      sortable: false,
    },
    {
      id: ORDER_SORT.DATE,
      label: resources.createdOnLabel,
      sortable: false,
    },
    {
      id: ORDER_SORT.INVOICE,
      label: resources.invoiceLabel,
      sortable: false
    }
  ];

  const sortHandler = (sortBy: ORDER_SORT) => {
    //  disabled
  };

  useEffect(() => {
    if (pages && pages.length > 0) {
      let list: IOrder[] = [];
      pages.forEach((page) =>
        page.items.forEach((item) => list.push(item))
      );

      // no sorting applied but structure ready
      setItems(list);
    }
  }, [pages, order, orderBy]);

  return (
    <div className="table-responsive overflow-auto" style={{ maxHeight: 500 }}>
      <InfiniteScroll
        element="table"
        className="table table-custom table-hover align-middle p-3"
        loadMore={fetchMoreHandler}
        hasMore={hasMore}
        loader={
          <tbody key={Math.random()}>
            <TableSkeleton colSpan={8} />
          </tbody>
        }
        threshold={0}
        useWindow={false}
        initialLoad={false}
      >
        <thead>
          <SortableListHeader
            headerItems={headerItems}
            sortHandler={(id) => sortHandler(id as ORDER_SORT)}
            hasActions
          />
        </thead>

        <tbody>
          {isLoading ? (
            <TableSkeleton colSpan={8} />
          ) : isError ? (
            <tr>
              <td colSpan={8} className="border-0 text-center">
                <Error />
              </td>
            </tr>
          ) : items && items.length > 0 ? (
            items.map((item) => (
              <OrdersListItem key={item.orderNo} item={item} />
            ))
          ) : (
            <tr>
              <td colSpan={8} className="border-0 text-center">
                <EmptyState title={resources.noDataTitle} />
              </td>
            </tr>
          )}
        </tbody>
      </InfiniteScroll>
    </div>
  );
};

export default OrdersList;